import React from 'react';
import { useAccount } from '~/accountContext';
import WelcomeChecklist from '~/welcome-checklist';
import PropTypes from 'prop-types';

const WELCOME_CHECKLIST_START_DATE = new Date('2023-01-23T00:00:00.000Z');

// This component serves as an additional wrapper to the WelcomeChecklist logic.
// Here we determine whether a user in the split group is eligible to see the checklist.
const WelcomeChecklistContainer = ({
  setShowAddChannels,
  setShowManageChannels,
}) => {
  const { account } = useAccount();

  const isOneBufferOrganization =
    account?.currentOrganization?.isOneBufferOrganization;
  const orgCreatedAt =
    new Date(account?.currentOrganization?.createdAt) || null;
  const isLaunchEligible = orgCreatedAt > WELCOME_CHECKLIST_START_DATE || false;

  return (
    <>
      {isOneBufferOrganization && isLaunchEligible && (
        <WelcomeChecklist
          setShowAddChannels={setShowAddChannels}
          setShowManageChannels={setShowManageChannels}
        />
      )}
    </>
  );
};

WelcomeChecklistContainer.propTypes = {
  setShowAddChannels: PropTypes.func,
  setShowManageChannels: PropTypes.func,
};

WelcomeChecklistContainer.defaultProps = {
  setShowAddChannels: () => {},
  setShowManageChannels: () => {},
};

export default WelcomeChecklistContainer;
